'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/** todo: rewrite to EventTarget*/
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this.repository = {};
        this.repositoryOne = {};
    }
    EventEmitter.prototype.on = function (eventName, handler) {
        this.repository[eventName] = this.repository[eventName] || [];
        this.repository[eventName].push(handler);
        return { eventName: eventName, handler: handler };
    };
    EventEmitter.prototype.one = function (eventName, handler) {
        this.repositoryOne[eventName] = this.repositoryOne[eventName] || [];
        this.repositoryOne[eventName].push(handler);
        return { eventName: eventName, handler: handler };
    };
    EventEmitter.prototype.off = function (eventName, handler) {
        if (!handler) {
            return this.remove(eventName);
        }
        if (this.repository[eventName]) {
            var position = this.repository[eventName].indexOf(handler);
            if (position !== -1) {
                this.repository[eventName].splice(position, 1);
            }
            return true;
        }
        if (this.repositoryOne[eventName]) {
            var position = this.repositoryOne[eventName].indexOf(handler);
            if (position !== -1) {
                this.repositoryOne[eventName].splice(position, 1);
            }
            return true;
        }
        return true;
    };
    EventEmitter.prototype.remove = function (eventName) {
        if (this.repository[eventName]) {
            delete this.repository[eventName];
        }
        if (this.repositoryOne[eventName]) {
            delete this.repositoryOne[eventName];
        }
        return true;
    };
    EventEmitter.prototype.emit = function (eventName, data) {
        if (this.repositoryOne[eventName]) {
            while (this.repositoryOne[eventName].length) {
                (this.repositoryOne[eventName].shift())(data, data); //two "data" for backward compatibility with old versions
            }
            delete this.repositoryOne[eventName];
        }
        if (this.repository[eventName]) {
            this.repository[eventName].map(function (callback) {
                callback(data, data); //two "data" for backward compatibility with old versions
            });
        }
    };
    return EventEmitter;
}());
var eventEmitter = new EventEmitter();

exports.EventEmitter = EventEmitter;
exports.eventEmitter = eventEmitter;
